import styled from "styled-components";
import React from "react";

export const Container = styled.div`
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  margin-top: 16px;
  justify-content: center;
  border: 1px solid #ececec;
  box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.1);
  background-color: ${({ theme }) => theme.colors.WHITE};
`;

export const Title = styled.div`
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 16px;
  margin-top: 16px;
  padding: 24px 40px 0px 40px;
`;

export const Complete = styled.div`
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.WHITE};
  min-height: 131px;
  @media (max-width: 768px) {
    width: 100%;
  }
  width: 640px;
  padding: 24px 40px 40px 40px;
  box-sizing: border-box;
  font-size: 16px;
`;

export const PartnerImageContainer = styled.div`
  position: relative;
  overflow: hidden;
  margin-top: 16px;
  display: flex;
  justify-content: center; /* 가로축 중앙 정렬 */
  align-items: center; /* 세로축 중앙 정렬 */
`;

export const PartnerImage = styled.div<{ image: string }>`
  background-image: url(${({ image }) => image});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  position: relative;
  width: 40px;
  height: 40px;
  max-height: 40px;
  z-index: 20;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }

  @media (max-width: 768px) {
    margin-bottom: 12px;
  }
`;
